<div
  class="flex cursor-pointer items-center gap-4 border-b border-neutral-100 px-4 py-3 hover:bg-neutral-50"
  (click)="open.emit()"
>
  <div class="flex min-w-0 flex-1 flex-col gap-1">
    <div class="flex items-center gap-2">
      <span class="truncate font-medium text-neutral-700">{{ protocol().name }}</span>
      @if (protocol().needsReview) {
        <span class="bg-warning-50 text-warning-700 shrink-0 rounded-full px-2 py-0.5 text-xs font-medium">
          {{ "protocols.list.needsReview" | translate }}
        </span>
      }
    </div>
    @if (identifiers().length) {
      <div class="flex flex-wrap gap-1">
        @for (identifier of identifiers(); track $index) {
          <span class="rounded bg-neutral-100 px-2 py-0.5 text-xs text-neutral-500">{{ identifier }}</span>
        }
      </div>
    }
  </div>

  <div class="hidden max-w-[16rem] flex-wrap gap-1 md:flex">
    @for (tag of protocol().coverage; track tag) {
      <span class="bg-primary-50 text-primary-600 rounded-full px-2 py-0.5 text-xs">{{ tag }}</span>
    }
  </div>

  <label
    class="flex shrink-0 items-center gap-2"
    (click)="$event.stopPropagation()"
  >
    <input
      type="checkbox"
      [checked]="protocol().enabled"
      (change)="onToggle($event)"
    />
    <span class="text-xs text-neutral-500">
      {{ (protocol().enabled ? "protocols.list.enabled" : "protocols.list.disabled") | translate }}
    </span>
  </label>

  <button
    type="button"
    class="hover:text-error-600 flex shrink-0 items-center text-neutral-400"
    [attr.aria-label]="'protocols.list.delete' | translate"
    (click)="onDelete($event)"
  >
    <mat-icon>delete</mat-icon>
  </button>
</div>
